import apolloCliente from '../apollo-client'
import gql from 'graphql-tag'

import env from '../config/environment'
import { setSessionStorageItem } from '../utils/helpers'

export default {

  async getAllFromUser() {
    const query = gql`
      query EmpresasList {
        usuarioAtual {
          permissoes {
            id
            admin
            empresa: partialEmpresa {
              id
              raizCnpj
              razaoSocial
              contrato(withCliente: false) {
                id
                diasAcessoRestantes
              }
            }
          }
        }
      }
    `

    try {
      const r = await apolloCliente.query({ query })
      const permissoes = r.data.usuarioAtual.permissoes;
      const empresas = permissoes
        .map(({ id, admin, empresa }) => {
          const { diasAcessoRestantes, ...contrato } = { ...empresa.contrato }

          return {
            ...empresa,
            id: parseInt(empresa.id),
            hasContrato: empresa.contrato ? true : false,
            contrato: {
              ...contrato,
              diasAcessoRestantes,
              inadimplente: diasAcessoRestantes && diasAcessoRestantes < 1
            },
            permissao: { id, admin }
          }
        })

      return empresas
    } catch (e) {
      console.log('error-getAllFromUser', e)
    }
  },

  async getEmpresa(empresaId) {
    try {
      const query = gql`
      query GetEmpresa($empresaId: Int!) {
        empresa(id: $empresaId) {
          id
          razaoSocial
          raizCnpj
          filiais {
            id
            cnpj
            razaoSocial
            pisCofinsVigente {
              id
              simplesNacional
              geraCredito
              regimeTributario {
                id
                tipo
              }
            }
            cidade {
              id
              nome
              estado {
                id
                sigla
              }
            }
          }
        }
      }
    `

      const r = await apolloCliente.query({ query, variables: { empresaId: parseInt(empresaId) } })
      const { empresa } = r.data

      return {
        ...empresa,
        filiais: empresa.filiais.map(filial => this._formatFilial(filial))
      }

    } catch (e) {
      console.log('error-getEmpresa', e)
    }
  },

  async getFiliais(empresaId) {
    try {
      const query = gql`
        query Empresas($empresaId: Int!) {
          usuarioAtual {
            id
            permissoes(filter: {empresaId: $empresaId}) {
              id
              admin
              filiais {
                id
                cnpj
                razaoSocial
                ferramentasDisponiveis
                icms {
                  id
                  simplesNacional
                }
                pisCofinsVigente {
                  id
                  simplesNacional
                  geraCredito
                  regimeTributario {
                    id
                    tipo
                  }
                }
                cidade {
                  id
                  nome
                  estado {
                    id
                    sigla
                  }
                }
              }
            }
          }
        }
      `

      const r = await apolloCliente.query({
        query,
        variables: { empresaId }
      })

      const { usuarioAtual: { permissoes: [{ filiais }] } } = r.data
      const f = filiais.map(filial => this._formatFilial(filial))
      setSessionStorageItem(env.filiais_session, f)
      return f
    } catch (e) {
      console.log('error-getFiliais', e)
    }
  },

  _formatFilial(filial) {
    return {
      ...filial,
      id: filial.id,
      cidade: filial.cidade.nome,
      estado: filial.cidade.estado.sigla
    }
  }

}
